import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/electrical';
const INCLUDED = ['6 Professional Diagnostic Modules', '4 Professional Bonuses', 'Visual Diagnostic Maps', 'Troubleshooting Flowcharts', 'Symptom-Based Pathways', 'Circuit & Component References', 'Testing & Measurement Resources', 'Field Organization Tools'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-navy px-4 py-4 sm:py-6" data-id="element-103" data-mp="u0oe0w5b788d">
      <div className="mx-auto max-w-3xl" data-id="element-104" data-mp="p1biln0dgsu6">
        <p className="text-center font-head text-[10px] font-extrabold uppercase tracking-[0.2em] text-volt sm:text-xs" data-id="element-105" data-mp="13wrezyofd0tq">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-0.5 text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-106" data-mp="ywmw6201nu0c">
          ⚡ ELECTRICAL DIAGNOSTIC PRO™
        </h2>
        <p className="mt-0.5 text-center font-head text-[11px] font-bold uppercase tracking-wide text-white/85 sm:text-sm" data-id="element-107" data-mp="2add3xpk48tw2">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR ELECTRICAL
          PROFESSIONALS
        </p>

        <div className="mt-2 rounded-xl border-2 border-volt bg-white p-2.5 sm:p-4" data-id="element-108" data-mp="ui8upufzbyf4">
          <div className="grid gap-2 sm:grid-cols-2 sm:items-center" data-id="element-109" data-mp="zi53s83jag1j">
            <a href={CHECKOUT_URL} className="block" data-id="element-110" data-mp="13k05vetagxgd">
              <img src={HERO_IMAGE} alt="Everything included in ELECTRICAL DIAGNOSTIC PRO™" loading="lazy" className="mx-auto w-full max-w-[240px]" data-id="element-111" data-mp="13jgl7qc97uyn" />
            </a>
            <div data-id="element-112" data-mp="fuffiaut2xx2">
              <p className="font-display text-base uppercase text-navy sm:text-lg" data-id="element-113" data-mp="ftw2n8k0izpw">
                Complete 6-in-1 Visual Diagnostic System
              </p>
              <ul className="mt-1 grid gap-0.5" data-id="element-114" data-mp="kn8k8yq9y695">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-semibold text-carbon" data-id="element-115" data-mp="3k6jegk6vqs2l">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy" aria-hidden="true" strokeWidth={3} data-id="element-116" data-mp="vefu24hea925" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-2 border-t border-navy/10 pt-2 text-center" data-id="element-117" data-mp="1078yer8ybfdp">
            <p className="font-display text-lg uppercase text-alert sm:text-xl" data-id="element-118" data-mp="chxskvcquusp">
              🔥 GET ELECTRICAL DIAGNOSTIC PRO™ TODAY
            </p>
            <p className="font-display text-5xl leading-none text-navy sm:text-6xl" data-id="element-119" data-mp="7k4lm03m9wrd">
              $27
            </p>
            <CTAButton href={CHECKOUT_URL} className="mx-auto mt-1.5 max-w-md" sub="Immediate Digital Access" data-id="element-120" data-mp="hg7sfj9eyjkn">
              ⚡ YES! I WANT THE COMPLETE SYSTEM
            </CTAButton>
            <p className="mt-1 text-[11px] font-bold text-carbon/80 sm:text-xs" data-id="element-121" data-mp="1sucw0b5psrfg">
              🛡️ 7-Day Money-Back Guarantee{' '}
              <span className="text-navy" data-id="element-122" data-mp="20h08xfymf5dj">⚡ COMPLETE 6-IN-1 SYSTEM</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}